import { Link } from 'react-router-dom'
import { Icons } from '@/theme/Images'
import { useGetRecurringPayment } from '../../hooks/use-get-recurring-payment'
import PropTypes from 'prop-types'
import { AUTOPAY_RETRIEVED } from '../data'
import { useEffect, useState } from 'react'

export default function AutoPayIndicator({ page }) {
  const { data } = useGetRecurringPayment()
  const [autoPayActive, setAutoPayActive] = useState(false)

  useEffect(() => {
    if (!data) {
      setAutoPayActive(false)
      return
    }

    setAutoPayActive(data.message.includes(AUTOPAY_RETRIEVED))
  }, [data])

  return (
    <div
      className={`flex flex-row ${
        autoPayActive && (page.trim() === 'accountBalance' || page.trim() === 'accountSummary')
          ? 'justify-center flex-row '
          : !autoPayActive && page === 'accountSummary'
            ? 'justify-between flex-row md:items-end md:flex-col gap-1'
            : 'justify-between flex-row'
      } pt-2 flex-row md:justify-end md:ml-6 md:mt-[-5px]`}
    >
      <div className={`flex`}>
        <img src={autoPayActive ? Icons.blueIndicatorIcon : Icons.grayIndicatorIcon} alt="icon" className="mr-1" />
        <p className="text-right text-nowrap font-medium text-[12px] text-dGray-700">
          AutoPay {autoPayActive ? 'on' : 'off'}
        </p>
      </div>
      <div className={`flex ${page === 'makePayment' ? 'md:pl-4 pl-0' : null}`}>
        {!autoPayActive ? (
          <Link
            className="text-right font-medium text-[12px] text-dGray-700 underline cursor-pointer ml-2"
            to="/payments/auto-pay"
          >
            <button id="start-autopay-button" aria-label="Start AutoPay" className="text-nowrap underline">
              Start AutoPay
            </button>
          </Link>
        ) : null}
      </div>
    </div>
  )
}

AutoPayIndicator.propTypes = {
  page: PropTypes.string,
}
